import React, { useState} from 'react';

const EquipmentFilterContainerViewing = ({ layersVisibility, toggleLayerVisibility }) => {

  const [isVisibleDiv, setIsVisibleDiv] = useState(false);

  function toggleVisibilityDiv() {
    setIsVisibleDiv(!isVisibleDiv);
  }
    
  return (
  <React.Fragment>
  <button onClick={toggleVisibilityDiv} className={isVisibleDiv ? 'buttonIsHideDrawer' : 'buttonIsHideDrawer2'}>
    {isVisibleDiv ? 'Оборудование: скрыть' : 'Оборудование: показать'}
  </button>

 {isVisibleDiv && ( 
    <div className='equipmentDiv' style={{marginTop: "10px",textShadow: '2px 2px 4px #242424'}}>
      <label className='typeLabelDiv'>Узлы</label>
      <hr className='horizontalLineDrawer'/>
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <input
          type="checkbox"
          checked={layersVisibility.iconSummit}
          onChange={() => toggleLayerVisibility('iconSummit')}
          style={{ marginRight: '5px' }}
        />
        <label style={{ marginRight: '10px' , color: '#bdbdbd'}}>100K</label>
      </div>

      <div style={{ display: 'flex', alignItems: 'center' }}>
        <input
          type="checkbox"
          checked={layersVisibility.icon30k}
          onChange={() => toggleLayerVisibility('icon30k')}
          style={{ marginRight: '5px' }}
        />
        <label style={{ marginRight: '10px', color: '#bdbdbd' }}>30K</label>
      </div>

      <div style={{ display: 'flex', alignItems: 'center' }}>
        <input
          type="checkbox"
          checked={layersVisibility.icon3k}
          onChange={() => toggleLayerVisibility('icon3k')}
          style={{ marginRight: '5px' }}
        />
        <label style={{ marginRight: '10px', color: '#bdbdbd' }}>3K</label>
      </div> 

      <div style={{ display: 'flex', alignItems: 'normal' }}>
        <input
          type="checkbox"
          checked={layersVisibility.iconKp}
          onChange={() => toggleLayerVisibility('iconKp')}
          style={{ marginRight: '5px' }}
        />
        <label style={{color: '#bdbdbd'}}>Контроль питания</label>
      </div>

      <div style={{ display: 'flex', alignItems: 'center' }}>
        <input
          type="checkbox"
          checked={layersVisibility.icon100pab}
          onChange={() => toggleLayerVisibility('icon100pab')}
          style={{ marginRight: '5px' }}
        />
        <label style={{ marginRight: '10px', color: '#bdbdbd'}}>100ПАБ</label>
      </div>                 
    </div>  
     )}
     </React.Fragment>
  );
}

export default EquipmentFilterContainerViewing;